import PropTypes from "prop-types"
import { get } from "lodash"
import { Link } from "react-router-dom"
import DisabledAction from "../disabled-action"

export default function LinkAction({ to, onClick, disabled, children }) {
  const text = get(children, "props.children", children)
  if (disabled) {
    return <DisabledAction>{text}</DisabledAction>
  }
  return <Link className="resource-action" to={to} onClick={onClick}>{text}</Link>
}

LinkAction.propTypes = {
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
